<template>
  <div id="noResults">{{this.$store.state.miscData.miscData.NoResultsText}}</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
#loading {
  display: flex;
  justify-content: center;
}
</style>
